var $PirForm;
var PirCaptchaRendered = false;

function onPirSubmit(token) {
  $PirForm.submit();
}

$(function() {
  $PirForm = $('#pir-form');

  if($PirForm.length > 0) {
    $PirForm.parsley({
      excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], [disabled]'
    }).on('form:validate', function(instance) {
      if(!PirCaptchaRendered && instance.isValid()) {
        if(grecaptcha.getResponse() !== '') {
          grecaptcha.reset();
        }
        grecaptcha.execute();

        PirCaptchaRendered = true;
      }
    }).on('form:submit', function(instance) {
      return grecaptcha.getResponse() !== '';
    });
  }

});